import { createContext, useContext, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";

// Colonne contextuelle desktop (≥ xl, cf. §6) : carte de suivi, détail de
// mission, récapitulatif persistant.
//
// Le conteneur n'existe QUE au-dessus de xl. En dessous, <ShellAside> ne rend
// rien — l'écran est responsable d'afficher ce contenu dans son flux normal.
// C'est volontaire : sur mobile ce contenu est un écran à part entière, pas une
// colonne, et le forcer dans un conteneur caché doublerait le rendu.

const AsideTargetContext = createContext<HTMLElement | null>(null);

export function AsideTargetProvider({
  children,
  target,
}: {
  children: ReactNode;
  target: HTMLElement | null;
}) {
  return <AsideTargetContext.Provider value={target}>{children}</AsideTargetContext.Provider>;
}

/** Renvoie `true` si la colonne contextuelle est montée (viewport ≥ xl). */
export function useHasAside(): boolean {
  return useContext(AsideTargetContext) !== null;
}

/** Projette son contenu dans la colonne contextuelle, ou rien si absente. */
export function ShellAside({ children }: { children: ReactNode }) {
  const target = useContext(AsideTargetContext);
  if (!target) return null;
  return createPortal(children, target);
}

/** Réf. de montage du conteneur, consommée par AppShell. */
export function useAsideTarget() {
  return useState<HTMLElement | null>(null);
}
